import React from "react";
import Routes from "./routes";
import "./App.css";

export default function App () {
  return <Routes />;
}